import NewBotForm from './NewBotForm'

export default NewBotForm